import { useQuery } from '@tanstack/react-query'
import { listOverrideRules } from '../../../../../api/plan-benefit-override-rules-api'
import type { ListPlanBenefitOverrideRulesQueryDto } from '../../../../../api/dto/plan-benefit-override-rules.dto'

export const OVERRIDE_RULES_QUERY_KEY = 'overrideRules'

export function useGetOverrideRules(
  params: ListPlanBenefitOverrideRulesQueryDto
) {
  const { data, isLoading, error } = useQuery({
    queryKey: [OVERRIDE_RULES_QUERY_KEY, params],
    queryFn: () => listOverrideRules(params),
    staleTime: 30_000,
  })

  return {
    items: data?.data ?? [],
    total: data?.meta.total ?? 0,
    page: data?.meta.page ?? 1,
    limit: data?.meta.limit ?? 20,
    totalPages: data?.meta.totalPages ?? 0,
    isLoading,
    error,
  }
}
